var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "black",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.5C43.1878 0.5 55.5 12.8122 55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28C0.5 12.8122 12.8122 0.5 28 0.5Z",
    stroke: "url(#paint0_linear_27627_1620)",
    strokeOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27627_1620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5462 16.8H18.4534C18.0148 16.8 17.5942 16.9743 17.2841 17.2844C16.974 17.5945 16.7998 18.0151 16.7998 18.4536V37.5465C16.7998 37.985 16.974 38.4056 17.2841 38.7157C17.5942 39.0258 18.0148 39.2 18.4534 39.2H37.5462C37.9848 39.2 38.4054 39.0258 38.7155 38.7157C39.0256 38.4056 39.1998 37.985 39.1998 37.5465V18.4536C39.1998 18.0151 39.0256 17.5945 38.7155 17.2844C38.4054 16.9743 37.9848 16.8 37.5462 16.8ZM23.4762 35.882H20.1085V25.1845H23.4762V35.882ZM21.79 23.702C21.408 23.6999 21.0352 23.5846 20.7186 23.3708C20.4021 23.157 20.1559 22.8541 20.0113 22.5006C19.8667 22.147 19.83 21.7585 19.906 21.3841C19.9819 21.0097 20.1671 20.6662 20.4381 20.3969C20.7091 20.1276 21.0538 19.9447 21.4286 19.8711C21.8035 19.7976 22.1918 19.8367 22.5444 19.9836C22.8971 20.1305 23.1983 20.3786 23.4101 20.6965C23.6219 21.0145 23.7348 21.388 23.7345 21.77C23.7381 22.0258 23.6901 22.2797 23.5935 22.5165C23.4969 22.7534 23.3537 22.9684 23.1722 23.1486C22.9908 23.3289 22.7749 23.4708 22.5374 23.5659C22.2999 23.661 22.0458 23.7073 21.79 23.702ZM35.8896 35.8914H32.5234V30.0472C32.5234 28.3236 31.7907 27.7916 30.8449 27.7916C29.8463 27.7916 28.8662 28.5445 28.8662 30.0907V35.8914H25.4985V25.1923H28.7371V26.6747H28.7807C29.1058 26.0167 30.2445 24.892 31.982 24.892C33.8611 24.892 35.8911 26.0074 35.8911 29.274L35.8896 35.8914Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27627_1620",
    x1: 28,
    y1: 0.00000105798,
    x2: 63.5,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27627_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 22.4,
    fill: "white",
    transform: "translate(16.7998 16.8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.33a721bc9d82f5910170cb451e86fc97.svg";
export { ForwardRef as ReactComponent };